
interface BlobItem {
  blob: Blob;
  key: string;
}

export class BlobCache {
  public size:number = 0;
  private sizeLimit:number = 15000000;

  private list: BlobItem[] = [];

  constructor(sizeLimitMB?:number) {
    if (sizeLimitMB) {
      this.sizeLimit = sizeLimitMB * 1000000;
    }
  }

  public add (key: string, blob:Blob) {
    const object:BlobItem = {key, blob};
    this.size += blob.size;

    this.list = [object, ...this.list];
    while (this.size > this.sizeLimit) {
      const last = this.list.pop();
      this.size -= last.blob.size;
    }
  }

  public remove (key:string) {
    this.list = this.list.filter(item => item.key !== key);
  }

  private getItem (key:string) {
    const index = this.list.findIndex(i => i && i.key === key);
    const item = this.list[index];
    if(index > 0) {
      this.list = [item, ...this.list.filter(i => i !== item)];
    }

    return item;
  }

  public get (key:string) {
    const item = this.getItem(key);
    return item ? item.blob : null;
  }
}
